<template>
  <HvhModal :value="true" :title="title" max-width="100%" persistent @input="$emit('input')">
    <DataTableAsync :data="tableData" v-model="tableState" :length="(data || []).length" :isLoading="isLoading">
      <template #head>
        <tr>
          <Th :prop="(f) => fullName(f)" sort v-if="!group">Physician Name</Th>
          <Th prop="oasTerritoryName" sort>Territory Name</Th>
          <Th prop="physicianGroupState" sort>State</Th>
          <Th prop="physicianGroupCity" sort>City</Th>
          <!-- <Th prop="locationName" sort>Location Name</Th> -->
          <Th prop="organizationName" sort>Organization Name</Th>
          <!-- <Th prop="physicianGroupList.physicianGroupAffiliationName" sort>Group Affiliation Name</Th> -->
          <Th prop="physicianGroupMainSpecialty" sort>Main Specialty</Th>
          <!-- <Th prop="physicianGroupList.rodRegionName" sort>Region</Th> -->
          <!-- <Th prop="physicianGroupType" sort>Physician Group Type</Th> -->
          <!-- <Th prop="decileMarketBasketProstateCancerPatients" sort>Decile</Th> -->
          <!-- <Th prop="callFrequency" sort>Call Frequency</Th> -->
          <th></th>
          <th></th>
        </tr>
      </template>
      <template #body="{ item }">
        <tr>
          <td v-if="!group">{{ fullName(item) }}</td>
          <td>{{ item.oasTerritoryName }}</td>
          <td>{{ item.physicianGroupState }}</td>
          <td>{{ item.physicianGroupCity }}</td>
          <!-- <td>{{ item.locationName }}</td> -->
          <td>{{ item.organizationName }}</td>
          <!-- <td>{{ item.physicianGroupList.physicianGroupAffiliationName }}</td> -->
          <td>{{ item.physicianGroupMainSpecialty }}</td>
          <!-- <td>{{ item.physicianGroupList.rodRegionName }}</td> -->
          <!-- <td>{{ item.physicianGroupType }}</td> -->
          <!-- <td>{{ item.decileMarketBasketProstateCancerPatients }}</td> -->
          <!-- <td class="text-center">
            <span class="link" @click="requestChangeCallFrequency(item)">{{ item.callFrequency || '-' }}</span>
          </td> -->
          <td>
            <v-switch :value="!!item.id" @change="$event ? addPhysician(item) : removePhysician(item)" />
          </td>
        </tr>
      </template>
    </DataTableAsync>
  </HvhModal>
</template>

<script>
import axios from '../../axios'
import { errorDebug, toFormData, tryParse } from '../../libraries/common';
import HvhModal from '../common/modal/HvhModal.vue'
import DataTableAsync from '../../components/common/dataTable/DataTableAsync.vue';
import Th from '../../components/common/dataTable/Th.vue';
export default {
  components: { HvhModal, DataTableAsync, Th, },
  props: ['value', 'brandId', 'userId', 'group'],
  data() {
    return {
      searchItems: [],
      isLoading: false,
      data: null,
      tableState: { page: 1, perPage: 25, searchText: null, },
    };
  },
  computed: {
    tableData() {
      var response = this.data || [];
      if (this.tableState.sortByProp) {
        var sortFnc = new Function('value', `return value.${this.tableState.sortByProp}`);
        response = response.sortBy(sortFnc);
        if (this.tableState.sortDirection === 'desc')
          response = response.reverse();
      }

      return response
        .skip(this.tableState.perPage * (this.tableState.page - 1))
        .take(this.tableState.perPage);
    },
    endpoint() {
      return this.group ? 'PhysicianGroups' : 'Physicians';
    },
    title() {
      return this.group ? 'Add Physician Group' : 'Add Physician';
    },
  },
  methods: {
    getData() {
      this.isLoading = true;
      if (this.cancelRequest)
        this.cancelRequest();
      axios.get(`/api/CallPlanning/${this.brandId}/User/${this.userId}/${this.endpoint}`,
        {
          params: { searchText: this.tableState.searchText },
          cancelToken: new axios.CancelToken(c => this.cancelRequest = c)
        })
        .then(({ data }) => {
          this.data = data.map(f => ({ ...f, additionalData: tryParse(f.additionalData) }));
          this.isLoading = false;
        })
        .catch(error => {
          if (!axios.isCancel(error)) {
            errorDebug(error);
            this.isLoading = false
          }
        });
    },
    addPhysician(item) {
      this.isLoading = true;
      var formData = this.group ? toFormData({ hospitalId: item.hospitalId }) : toFormData({ npi: item.npi });
      axios.post(`/api/CallPlanning/${this.brandId}/User/${this.userId}/${this.endpoint}`, formData)
        .then(({ data }) => {
          item.id = data.id;
          this.$emit('addTarget', data);
        })
        .catch(errorDebug)
        .then(() => this.isLoading = false);
    },
    removePhysician(item) {
      this.isLoading = true;
      axios.delete(`/api/CallPlanning/${this.brandId}/User/${this.userId}/${this.endpoint}/${item.id}`)
        .then(() => this.$emit('removeTarget', item))
        .catch(errorDebug)
        .then(() => this.isLoading = false);
    },
    fullName(item) {
      return [item.physicianFirstName, item.physicianLastName]
        .filter(f => f)
        .join(' ');
    },
  },
  watch: {
    'tableState.searchText'() {
      this.getData();
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisCallPlanningAddPhysician'] = this;

    this.getData();
  }
}
</script>